<template>
  <v-container>
    <p class="msg-info">{{$tf('RestoreMagicLinkMessage')}}</p>
    <div class="magic-link-wrapper">
      <div class="link-info">
        <div class="link-pin-copy">
          <div class="key">{{$tf('URL')}}</div>
          <div class="value">
            <span>{{magicLinkURL}}</span>
          </div>
        </div>
        <div class="link-pin-copy">
          <div class="key">{{$tf('PIN')}}</div>
          <div class="value">
            <span>{{magicLinkSSID}}</span>
          </div>
        </div>
        <div v-if="sharedWith.public_url.has_password" class="caption grey--text text--darken-1 pt-1 pb-1">
          {{ $tf('MagicLinkPasswordMessage') }}
        </div>
        <div v-else class="caption grey--text text--darken-1 pt-1 pb-1">
          {{ $tf('NoPassword') }}
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'expired-magic-link',
    props: {
      sharedWith: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      magicLinkIsEnabled () {
        return this.sharedWith && this.sharedWith.public_url && this.sharedWith.public_url.public_url_id
      },
      magicLinkURL () {
        return this.magicLinkIsEnabled
          ? `${window.location.origin}/v/${this.sharedWith.public_url.namespace}`
          : `${window.location.origin}/v/${this.$store.state.session.account.username}`
      },
      magicLinkSSID () {
        return this.magicLinkIsEnabled
          ? this.sharedWith.public_url.secure_id
          : null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .magic-link-wrapper {
    display: flex;
    flex-direction: column;

    .link-info {
      flex-grow: 1;
      .link-pin-copy {
        background-color: #F5F5F5;
        color: #333;
        display: flex;
        align-items: center;
        flex-grow: 1;
        border-radius: 2px;
        margin: 0.5rem 0;
        padding: 0;
        font-size: 18px;
        height: 45px;
        .key {
          font-weight: bold;
          margin-left: 1rem;
          width: 5rem;
        }
        .value {
          width: 5rem;
          flex-grow: 1;
          font-weight: normal;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .buttons {
      display: flex;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogExpiredMagicLink.vue